/** Alinhado ao hub: sem responsável ativo = pending ou open (inconsistente) + responsavelId nulo. */
export function conversaEhSemResponsavelAtiva(ticket) {
  if (!ticket || ticket.responsavelId != null) return false
  return ticket.status === "pending" || ticket.status === "open"
}

/** Conversa externa que o usuário pode assumir. */
export function conversaPodeAssumir(ticket, { lEhConversaInterna = false } = {}) {
  if (!ticket || lEhConversaInterna) return false
  return conversaEhSemResponsavelAtiva(ticket)
}

/** Marcador enviado à API no filtro da aba Sem Responsável (`responsavelId IS NULL`). */
export const FILTRO_USUARIO_SEM_RESPONSAVEL = null
